var CustomMapStyles = [
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#444444"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#f2f2f2"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#dbdbdb"
            },
            {
                "visibility": "on"
            }
        ]
    }
];


var mapMarkerPosition = {
    lat: -46.358228,
    lng: 168.346506
};

var mapPosition = {
    lat: -46.362591,
    lng: 168.326274
};

$(document).ready(() => {

    var map;
    var marker;

});

$(window).resize(() => {

    if($('#map').length) {

        window.mapResizer();

    }

});

window.mapResizer = function() {

  if (map) {

    if($(window).width() < 1000) {

        map.setCenter(mapMarkerPosition);

    } else {

        map.setCenter(mapPosition);

    }

  }

}

window.initMap = function() {

    map = new google.maps.Map(document.getElementById('map'), {
        center: mapPosition,
        zoom: 15,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        zoomControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        styles: CustomMapStyles
    });

    var iconScaledSize = new google.maps.Size(174, 223);

    if($(window).width() < (768 - 15)) {

      iconScaledSize = new google.maps.Size(.5 * 174, .5 * 223);

    }

    marker = new google.maps.Marker({
        position: mapMarkerPosition,
        map: map,
        title: 'Cobra Attachments',
        icon: {
            url: '/_resources/themes/custom/images/marker.svg',
            scaledSize: iconScaledSize,
            origin: new google.maps.Point(0,0),
            // anchor: new google.maps.Point(0,0)
        }
    });

    window.mapResizer();
}
